/* eslint-disable react/jsx-props-no-spreading */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import usePapiData from '../hooks/usePapiData';
import useGraphQL from '../hooks/useGraphQL';
import { getClickTrackingURLExtension, getSavingPercentage, useUniqueElementIndex, } from './Functions';
import WishListProvider from '../WishListProvider';
import Headline from '../Headline';
import { rdeTypes, } from './types';
import Slider from '../Slider';
import ProductLayoutProvider from '../ProductLayoutProvider';
import Product from '../Product';
import { SkeletonProvider } from '../Skeleton';
import { fetchConfig, sliderConfig, customProductLayouts } from './config';
import { RecoSliderWrapper, WrappedCard } from './styles';
import { useLazyLoad, LazyProvider } from '../LazyLoad';
import useTracking from '../hooks/useTracking';
var StyledHeadlineWithoutSpacer = styled(Headline)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n"], ["\n  margin-bottom: 1rem;\n"])));
var RecoSliderUnlazy = function (_a) {
    var _b = _a.cardLayout, cardLayout = _b === void 0 ? true : _b, headline = _a.headline, headlineElement = _a.headlineElement, headlineSpacer = _a.headlineSpacer, imageOrientation = _a.imageOrientation, _c = _a.lazyLoadItems, lazyLoadItems = _c === void 0 ? false : _c, pageTemplate = _a.pageTemplate, productBottomSlot = _a.productBottomSlot, _d = _a.productsToLoad, productsToLoad = _d === void 0 ? 20 : _d, _e = _a.ratingSymbol, ratingSymbol = _e === void 0 ? 'star' : _e, _f = _a.rdeRequest, rdeType = _f.rdeType, _g = _f.cid, cid = _g === void 0 ? '' : _g, _h = _f.articleNo, articleNo = _h === void 0 ? '' : _h, _j = _f.brand, brand = _j === void 0 ? '' : _j, _k = _f.price, price = _k === void 0 ? -1 : _k, _l = _f.available, available = _l === void 0 ? 0 : _l, _m = _f.searchTerm, searchTerm = _m === void 0 ? '' : _m, recoApi = _a.recoApi, _o = _a.showSavingFlag, showSavingFlag = _o === void 0 ? false : _o;
    var _p, _q, _r, _s, _t;
    var wasVisible = useLazyLoad();
    var dispatchGTMEvent = useTracking();
    var papiProducts = usePapiData('hotArticlesIntraday');
    var apiLocale = useIntl().locale;
    var _u = useUniqueElementIndex('recoSlider'), elementRef = _u[0], elementIndex = _u[1];
    var _v = useGraphQL(rdeType, {
        cid: cid,
        brand: brand,
        price: price,
        available: available,
        id: articleNo,
        item: articleNo,
        pid: articleNo,
        term: searchTerm,
        papiproducts: papiProducts,
        locale: apiLocale,
    }, {
        url: wasVisible ? recoApi : '',
        fetchConfig: __assign({}, fetchConfig),
    }), error = _v.error, isLoading = _v.isLoading, response = _v.response, areParamsSufficient = _v.areParamsSufficient;
    var _w = useState([]), fetchedProducts = _w[0], setFetchedProducts = _w[1];
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = response === null || response === void 0 ? void 0 : response.errors) === null || _a === void 0 ? void 0 : _a.length) {
            response.errors.forEach(function (_a) {
                var message = _a.message;
                // eslint-disable-next-line no-console
                console.error("RecoSlider #" + elementIndex + " (" + rdeType + "): " + message);
            });
            return;
        }
        if (rdeType && (response === null || response === void 0 ? void 0 : response.data) && ((_c = (_b = response.data[rdeType]) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.length)) {
            setFetchedProducts(response.data[rdeType].products.slice(0, productsToLoad));
        }
    }, [response, elementIndex]);
    useEffect(function () {
        if (error && wasVisible) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [error]);
    /** execute tracking, if component was seen */
    useEffect(function () {
        // execute seen tracking
        if (wasVisible && fetchedProducts.length && typeof elementIndex === 'number') {
            var akls = fetchedProducts.map(function (product) { return product.akl; });
            dispatchGTMEvent({
                event: 'ga_event',
                eventCategory: 'elementImpression',
                eventLabel: 'recoImpression',
                eventValue: {
                    rdeTypeAbbr: rdeTypes[rdeType] || rdeType,
                    outputElementNo: elementIndex + 1,
                    pageTemplate: pageTemplate,
                    akls: akls,
                },
            });
            // execute seen for criteo products (see JPWP-12403)
            if (rdeType === 'criteoProducts') {
                var products = (response === null || response === void 0 ? void 0 : response.data).criteoProducts.products;
                products === null || products === void 0 ? void 0 : products.forEach(function (product) {
                    var _a;
                    var url = ((_a = product.tracking) === null || _a === void 0 ? void 0 : _a.onViewUrl) || '';
                    if (url !== '')
                        fetch(url);
                });
            }
        }
    }, [wasVisible, fetchedProducts, elementIndex]);
    return (React.createElement(RecoSliderWrapper, { "data-testid": "recoSlider", ref: elementRef }, areParamsSufficient ? (React.createElement(ProductLayoutProvider, { customLayouts: customProductLayouts, layoutName: "defaultReco" },
        React.createElement(WishListProvider, null,
            React.createElement(SkeletonProvider, { isLoading: isLoading || !wasVisible }, Boolean(!wasVisible || isLoading || (!error && response && fetchedProducts.length)) && (React.createElement(React.Fragment, null,
                !cardLayout && (((_p = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _p === void 0 ? void 0 : _p.title) || headline) && !headlineSpacer && (React.createElement(StyledHeadlineWithoutSpacer, { level: 2, textAlign: "center", element: headlineElement }, ((_q = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _q === void 0 ? void 0 : _q.title) || headline)),
                !cardLayout && (((_r = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _r === void 0 ? void 0 : _r.title) || headline) && headlineSpacer && (React.createElement(Headline, { level: 2, spacer: headlineSpacer, textAlign: "center", element: headlineElement }, ((_s = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _s === void 0 ? void 0 : _s.title) || headline)),
                React.createElement(Slider, __assign({ styleType: "type2" }, sliderConfig(cardLayout, lazyLoadItems), {
                    headline: cardLayout ? ((_t = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _t === void 0 ? void 0 : _t.title) || headline : undefined,
                }), !wasVisible || isLoading
                    ? Array.from({ length: 10 }, function (v, i) { return (React.createElement(WrappedCard, { key: "skeleton-" + i, cardLayout: cardLayout },
                        React.createElement(Product, { key: i, imageOrientation: imageOrientation, list: rdeType, position: i + 1, priceLayout: "recoSlider" }))); })
                    : (response === null || response === void 0 ? void 0 : response.data[rdeType]) &&
                        fetchedProducts.map(function (product, index) {
                            var _a;
                            return product ? (React.createElement(WrappedCard, { key: product.orderNumber, cardLayout: cardLayout },
                                React.createElement(Product, { product: product, imageOrientation: imageOrientation, flagCustom: showSavingFlag
                                        ? { text: getSavingPercentage(product) }
                                        : undefined, priceLayout: "recoSlider", productLinkExtension: getClickTrackingURLExtension({
                                        cid: cid,
                                        pageTemplate: pageTemplate,
                                        productsToLoad: productsToLoad,
                                        rdeType: rdeTypes[rdeType] || rdeType,
                                        sourceArticleNo: articleNo,
                                        targetOrderNumber: product.orderNumber,
                                        position: index + 1,
                                        outputElementNo: (elementIndex || 0) + 1,
                                        recoLogic: ((_a = response === null || response === void 0 ? void 0 : response.data[rdeType]) === null || _a === void 0 ? void 0 : _a.recoLogic) || 'fallback',
                                    }), list: rdeType, position: index + 1, ratingSymbol: ratingSymbol, bottomSlot: productBottomSlot ? productBottomSlot(product) : undefined, bottomSlotHeight: "auto" }))) : null;
                        })))))))) : (React.createElement(React.Fragment, null))));
};
/**
 * Slider for recommendations. You have to specify rdeType & categoryId (cid) at minimum
 * @param rdeRequest Request object that contains required data for the RDEs
 */
var ProductRecoSlider = memo(function (recoSliderProps) { return (React.createElement(LazyProvider, null,
    React.createElement(RecoSliderUnlazy, __assign({}, recoSliderProps)))); });
export { ProductRecoSlider };
export default ProductRecoSlider;
var templateObject_1;
//# sourceMappingURL=index.js.map